import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { EmploymentRecordBenefit, EmploymentRecordBenefitSubmit } from '../models/employment-record-benefit.model';
import { EnvironmentService } from "@app/core/services/environment.service";


const headers = new HttpHeaders({
  'Content-Type':  'application/json',
});
@Injectable({
  providedIn: 'root'
})
export class EmploymentRecordBenefitsService {

  constructor(private http: HttpClient, private envService: EnvironmentService) { }

  getBenefits(employeeId: string, employmentRecordId: string, take?: number, skip?: number): Observable<any> {
    let params = new HttpParams();
    skip ? params = params.append('skip', skip) : null;
    take ? params = params.append('take', take) : null;

    return this.http
      .get<any>(this.envService.env.apiUrl + `Employee/${employeeId}/EmploymentRecord/${employmentRecordId}/Benefit`, {
        headers: headers,
        observe: 'response',
        params: params
      })
      .pipe(
        catchError(err => throwError(err)),
        map(res => {
          let data = {
            benefits: res.body,
            pagination: JSON.parse(res.headers.get('X-Pagination'))
          }

          return data;
        })
      );
  }

  getBenefit(employeeId: string, employmentRecordId: string, benefitId: string): Observable<EmploymentRecordBenefit> {
    return this.http.get<any>(this.envService.env.apiUrl + `Employee/${employeeId}/EmploymentRecord/${employmentRecordId}/Benefit/${benefitId}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  postBenefit(employeeId: string, employmentRecordId: string, employmentRecord: EmploymentRecordBenefitSubmit): Observable<EmploymentRecordBenefit> {
    return this.http.post<any>(this.envService.env.apiUrl + `Employee/${employeeId}/EmploymentRecord/${employmentRecordId}/Benefit`, employmentRecord, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  deleteBenefit(employeeId: string, employmentRecordId: string, benefitId: string): Observable<any> {
    return this.http.delete<any>(this.envService.env.apiUrl + `Employee/${employeeId}/EmploymentRecord/${employmentRecordId}/Benefit/${benefitId}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }
}
